export const messages = {
  en: {
    shop: {
      title: 'Shop Information',
      refresh: 'Refresh',
      addShop: 'Add Shop',
      shopLogo: 'Shop Logo',
      shopArea: 'Shop Area',
      shopName: 'Shop Name',
      shopId: 'Shop ID',
      openType: 'Open Type',
      shopDesc: 'Shop Description',
      returnContact: 'Return Contact',
      returnPhone: 'Return Phone',
      status: 'Status',
      operations: 'Operations',
      edit: 'Edit',
      payDeposit: 'Pay Deposit',
      qrCode: 'QR Code',
      addShopTitle: 'Add Shop',
      editShopTitle: 'Edit Shop',
      shopNamePlaceholder: 'Required, please enter shop name',
      shopTypePlaceholder: 'Required, please select shop type',
      openTypePlaceholder: 'Required, please select open type',
      shopDescPlaceholder: 'Required, please enter shop description',
      sendAddressPlaceholder: 'Required, please enter shipping address',
      returnContactPlaceholder: 'Required, please enter return contact',
      returnPhonePlaceholder: 'Required, please enter return phone',
      returnAddressPlaceholder: 'Required, please enter return address',
      province: 'Province',
      city: 'City',
      district: 'District',
      selectProvince: 'Select Province',
      selectCity: 'Select City',
      selectDistrict: 'Select District',
      depositAmount: 'Deposit Amount',
      coordinatesX: 'Coordinates X',
      coordinatesY: 'Coordinates Y',
      getCoordinates: 'Click map to get coordinates',
      location: 'Location',
      saveSuccessTip: 'After saving successfully, it can be used after administrator approval',
      save: 'Save',
      cancel: 'Cancel',
      modifyReason: 'Modification Reason',
      modifyReasonPlaceholder: 'Required, please enter modification reason',
      uploadImage: 'Upload Image',
      removeImage: 'Remove Image',
      imageSizeLimit: 'Image size cannot exceed 2MB!',
      uploadFailed: 'Upload failed'
    }
  },
  zh: {
    shop: {
      title: '店铺信息',
      refresh: '刷新',
      addShop: '开店',
      shopLogo: '店铺logo',
      shopArea: '店铺区域',
      shopName: '店铺名称',
      shopId: '店铺编号',
      openType: '开店类型',
      shopDesc: '店铺描述',
      returnContact: '退货联系人',
      returnPhone: '退货电话',
      status: '状态',
      operations: '操作',
      edit: '修改',
      payDeposit: '缴保证金',
      qrCode: '二维码',
      addShopTitle: '开店',
      editShopTitle: '修改店铺',
      shopNamePlaceholder: '必填，请填写商铺名称',
      shopTypePlaceholder: '必填，请选择商铺类型',
      openTypePlaceholder: '必填，请选择开店类型',
      shopDescPlaceholder: '必填，请填写商铺描述',
      sendAddressPlaceholder: '必填，请填写发货地址',
      returnContactPlaceholder: '必填，请填写退货联系人',
      returnPhonePlaceholder: '必填，请填写退货联系电话',
      returnAddressPlaceholder: '必填，请填写退货地址',
      province: '省',
      city: '市',
      district: '区县',
      selectProvince: '请选择省',
      selectCity: '请选择城市',
      selectDistrict: '请选择区县',
      depositAmount: '保证金金额',
      coordinatesX: '坐标X位置',
      coordinatesY: '坐标Y位置',
      getCoordinates: '请点击地图获取坐标',
      location: '定位',
      saveSuccessTip: '保存成功后，管理员审核通过即可使用',
      save: '保存',
      cancel: '取消',
      modifyReason: '修改原因',
      modifyReasonPlaceholder: '必填，请填写修改原因',
      uploadImage: '上传图片',
      removeImage: '删除图片',
      imageSizeLimit: '图片大小不能超过 2MB!',
      uploadFailed: '上传文件失败'
    }
  }
}